module.exports = __webpack_public_path__ + "assets/retina_TrapezoidCutDetailed.e7ece02a4db6f0d8e9ad2b9f77e3feac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_TrapezoidCutDetailed.png
// module id = 746
// module chunks = 0